import React, { useState } from 'react';
import { ContractType, ContractInfo } from 'cpie-common';
import { useTranslation } from 'react-i18next';
import { Combobox, FormField, ErrorMessage } from '@vwfs-bronson/bronson-react';
import { getInitialValues } from '../initialValues';
import { useField } from 'formik';
import { ComboboxState } from '../../../../types/bronson-react';

export type ContractSelectionProps = {
    contracts?: ContractInfo[];
};

export const ContractSelection: React.FC<ContractSelectionProps> = ({ contracts }) => {
    const { t } = useTranslation('request');
    const { t: cms } = useTranslation('request-cms');

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, meta, helpers] = useField('contractSelection');

    const [selectedContract, setSelectedContract] = useState({
        isOpen: false,
        value: [],
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const setValueChange = (selectedContractsNumbers: any) => {
        const { isActive, brand, contractNumber, licensePlate } = contracts?.find(
            ({ contractNumber }) => contractNumber === selectedContractsNumbers[0].key,
        ) || { brand: '', contractNumber: '', licensePlate: '' };

        const contractSelectionValues = {
            isActive,
            brand,
            contractNumber,
            registrationNumber: licensePlate,
        };
        helpers.setValue(contractSelectionValues || getInitialValues().contractSelection);
        setSelectedContract(prev => ({
            ...prev,
            value: selectedContractsNumbers,
        }));
    };

    if (!contracts) {
        return null;
    }

    const options = contracts.map(({ model, brand, licensePlate, contractNumber, contractType, isActive }) => {
        const getContractTypeValue = (): string => {
            const type = !isActive
                ? 'expired'
                : contractType === ContractType.HIRE_PURCHASE
                ? 'hire-purchase'
                : 'personal-contract-plan';
            return t(`contract-selection.contract-type.${type}`);
        };

        const carInformation = `${brand} ${model}, ${licensePlate}`;
        return {
            key: contractNumber || '',
            value: {
                textValue: contractNumber || '',
                content: (
                    <div>
                        <b>
                            {getContractTypeValue()} - {contractNumber}
                        </b>
                        <p>{brand && model && licensePlate && <span>{carInformation}</span>}</p>
                    </div>
                ),
            },
        };
    });

    const placeholderText = t('contract-selection.placeholder');

    const defaultState: ComboboxState = {
        value: [
            {
                value: placeholderText,
                key: 'placeholder',
            },
        ],
    };

    return (
        <FormField
            type="select"
            testId={'contract-selection'}
            labelId={'contract-selection-label'}
            labelText={cms('contract-selection.label')}
            required
            errorMessage={
                <ErrorMessage id="contract-selection" testId={'contract-selection-error-message'}>
                    {meta.touched && meta.error ? meta.error : ''}
                </ErrorMessage>
            }
        >
            <Combobox
                id="contract-selection"
                ariaLabelledBy="contract-selection-label"
                ariaDescribedBy="error-contract-selection"
                required
                testId="custom-contract-select"
                defaultState={defaultState}
                onChange={setValueChange}
                options={options}
                value={selectedContract.value}
                placeholder={placeholderText}
            />
        </FormField>
    );
};
